import React from 'react';
import cn from 'classnames';

import CTA from 'react-scale/components/ui/cta';
import MeshGradient from 'react-scale/components/ui/webgl/mesh-gradient';

const Hero = ({ theme, title, subtitle, icon, cta, webgl }) => (
  <div className="relative">
    <div className="absolute inset-0 z-0 bg-black pointer-events-none">
      <MeshGradient style={webgl.style} />
      <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
      <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
    </div>
    <div className="py-16 lg:py-32 xl:py-56 xl:pt-40">
      <div className="container relative">
        {icon ? (
          <img className={cn('mt-0  mb-8 h-16 md:h-18')} src={icon.src} alt={icon.alt} />
        ) : null}
        <h1
          className={cn(
            textTheme[theme],
            'font-aeonik font-light text-4xl md:text-7xl mb-8 text-white'
          )}
        >
          {title}
        </h1>
        <p className={cn(textTheme[theme], 'text-lg md:text-lg', { 'mb-8': cta })}>{subtitle}</p>
        {cta && <CTA theme={theme} cta={cta} />}
      </div>
    </div>
  </div>
);

const textTheme = {
  dark: 'text-white',
  light: 'text-black'
};

Hero.defaultProps = {
  theme: 'dark',
  icon: null,
  title: 'Our mission is to accelerate the development of AI applications.',
  subtitle:
    'Better data leads to more performant models. Performant models lead to faster deployment. We help deliver value from AI investments faster with better data by providing an end-to-end solution to manage the entire ML lifecycle.',
  cta: false,
  webgl: true
};

export default Hero;
